import { useTranslation } from 'react-i18next'

import { Wordmark } from './wordmark'

/**
 * The four policy links have no destinations in a single-page build, so they
 * render as `#` placeholders. Giving them real pages is the first thing that
 * would justify reintroducing a router.
 */
const FOOTER_LINKS = [
  { key: 'footer.privacy', href: '#' },
  { key: 'footer.terms', href: '#' },
  { key: 'footer.legal', href: '#' },
  { key: 'footer.sustainability', href: '#' },
] as const

export function SiteFooter() {
  const { t } = useTranslation()

  return (
    <footer className="bg-primary py-stack-lg">
      <div className="max-w-content gap-stack-md px-margin-mobile md:px-margin-tablet lg:px-margin-desktop mx-auto flex flex-col items-center text-center lg:flex-row lg:justify-between lg:text-left">
        <Wordmark className="text-on-primary" />

        <p className="text-body-md text-on-primary/70">
          {t('footer.copyright', { year: new Date().getFullYear() })}
        </p>

        <nav className="flex flex-wrap justify-center gap-4">
          {FOOTER_LINKS.map((link) => (
            <a
              key={link.key}
              href={link.href}
              className="text-label-md text-on-primary/70 hover:text-secondary-fixed rounded-sm transition-colors"
            >
              {t(link.key)}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  )
}
